/*
 * @Author: JamesWong
 * @Description: 应用版本中文包
 * @Date: 2018-11-29 15:14:04
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-29 16:02:07
 */
export default {
  appVersion: '应用版本',
  backstageVersion: '后台版本',
  enabledIOSVersion: '可使用的IOS版本',
  enabledAndroidVersion: '可使用的安卓版本',
  enabledPadVersion: '可使用的安卓平板版本',
  versionUpdateDesc: '版本更新说明',
  downloadQRcode: '下载二维码',
  downloadAddress: '下载地址',
  downloadArticle: '详细迭代推文',
  '版本详情': '版本详情',
  Close: '关闭',
  '点击详情': '点击详情',
  '未启用': '未启用',
  '可联系商务开通': '可联系商务开通',
  '下载链接': '下载链接',
  '下载': '下载'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/appversion.js